import apiClient from '@/utils/request'
import { nestedQueryFormatter } from '@/utils/query'
import {
  IRetargetingListResponse,
  IRetargetingListsPayload,
  IRetargetingListPayload
} from '@/apps/traforama/interfaces/retargetingLists'

export const fetchItems = async (
  payload: IRetargetingListsPayload
): Promise<IRetargetingListResponse> => {
  const params = Object.assign(
    { limit: payload.limit, start: payload.start },
    nestedQueryFormatter('filter', payload.filter, false)
  )
  const response = await apiClient.get<IRetargetingListResponse>(
    '/retargeting_lists',
    {
      params
    }
  )
  return response.data
}

export const updateItem = async (
  item: IRetargetingListPayload
): Promise<IRetargetingListResponse> => {
  const payload = { ...item }
  const response = await apiClient.put<IRetargetingListResponse>(
    `/retargeting_lists/${item.id}`,
    payload
  )
  return response.data
}
